import { PlusIcon } from "@xola/icons";
import { Breadcrumb, Button, HeaderToolbar } from "@xola/ui-kit";
import { orderBy } from "lodash";
import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { Experience } from "types";
import { ColumnLayout } from "../../components/Layout/ColumnLayout";
import { ExperienceList } from "../../components/Product/ExperienceList";
import { ExperienceSearch } from "../../components/Product/ExperienceSearch";
import { useAutoFetchCollection } from "../../hooks/useAutoFetchCollection";
import { useSearch } from "../../hooks/useSearch";
import { Page } from "../Page";

export const ExperienceListPage = () => {
    const [search, setSearch] = useState("");
    const { data: experiences, isLoading } = useAutoFetchCollection<Experience>("experiences");
    let filtered = useSearch(experiences, (experience) => [experience.name, experience.id], search);
    filtered = orderBy(filtered, (experience) => experience.name, ["asc"]);
    const isFiltered = search.length > 0;
    const history = useHistory();

    const handleCreateProductClick = () => {
        history.push("/products/experiences/new");
    };

    return (
        <Page title="Experiences">
            <ColumnLayout>
                <HeaderToolbar className="justify-between">
                    <HeaderToolbar.Breadcrumb>
                        <Breadcrumb.Item>Products</Breadcrumb.Item>
                        <Breadcrumb.Item>Experiences</Breadcrumb.Item>
                    </HeaderToolbar.Breadcrumb>

                    <ExperienceSearch onSearch={setSearch} />

                    <Button className="flex-shrink-0" icon={<PlusIcon />} onClick={handleCreateProductClick}>
                        Create Product
                    </Button>
                </HeaderToolbar>
                <ColumnLayout.Fill>
                    <ExperienceList experiences={filtered} isLoading={isLoading} isFiltered={isFiltered} />
                </ColumnLayout.Fill>
            </ColumnLayout>
        </Page>
    );
};
